import isTabReuseEnabled from './isTabReuseEnabled';
import * as storageKey from './storageKey';
import { getItem } from 'owa-local-storage';

export default function tryReuseOpenedTab(tabName: string): boolean {
    if (isTabReuseEnabled()) {
        const tabKey = storageKey.getTabKey(tabName);
        if (getItem(window, tabKey)) {
            let tabWindow = window.open('', tabKey);
            tabWindow.focus();
            return true;
        }
    }
    return false;
}
